import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WorkspaceData } from '../../types/auth.types';
import { IPermissions } from '../../types/roles.types';
interface AuthState {
    user: {
        id: string;
        email: string;
        two_factor_enabled: boolean;
        license_type?: string;
        trial_days_remaining?: number;
    } | null;
    isAuthenticated: boolean;
    role_id: number | null;
    team_id: string | null;
    activeWorkspaceId: string | null;
    activeWorkspace: WorkspaceData | null;
    workspaces: WorkspaceData[];
    permissions: IPermissions | null;
    loading: boolean;
    error: string | null;
}

const initialState: AuthState = {
    user: null,
    isAuthenticated: false,
    role_id: null,
    team_id: null,
    activeWorkspaceId: null,
    activeWorkspace: null,
    workspaces: [],
    permissions: null,
    loading: false,
    error: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (state, action: PayloadAction<any>) => {
            state.user = action.payload.user;
            state.isAuthenticated = action.payload.isAuthenticated !== undefined ? action.payload.isAuthenticated : true;
            state.role_id = action.payload.role_id;
            state.permissions = action.payload.permissions;
            state.team_id = action.payload.team_id;
            // Fix: Also persist activeWorkspaceId when setting credentials
            if (action.payload.activeWorkspaceId !== undefined) {
                state.activeWorkspaceId = action.payload.activeWorkspaceId;
            }
        },
        updateMfaStatus: (state, action: PayloadAction<boolean>) => {
            if (state.user) {
                state.user.two_factor_enabled = action.payload;
            }
        },
        updateLicenseType: (state, action: PayloadAction<string>) => {
            if (state.user) {
                state.user.license_type = action.payload;
                state.user.trial_days_remaining = 0;
            }
        },
        logout: (state) => {
            state.user = null;
            state.isAuthenticated = false;
            state.role_id = null;
            state.permissions = null;
            state.team_id = null;
            state.activeWorkspaceId = null;
            state.activeWorkspace = null;
            state.workspaces = [];
            state.loading = false;
            state.error = null;
        },
        setAuthActiveWorkspace: (state, action: PayloadAction<WorkspaceData>) => {
            state.activeWorkspace = action.payload;
            state.activeWorkspaceId = action.payload.id;
            
            // Update is_active flag in the workspaces array if it exists
            if (state.workspaces.length > 0) {
                state.workspaces = state.workspaces.map(workspace => ({
                    ...workspace,
                    is_active: workspace.id === action.payload.id
                }));
            }
        },
    }
});

export const { setCredentials, updateMfaStatus, updateLicenseType, logout, setAuthActiveWorkspace } = authSlice.actions;
export default authSlice.reducer;